
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { map } from 'lodash';
import cIf from 'classnames';
import TranslatorManager from 'ts-translate-js';
import { Modal } from "ts-common-react-controls";

const tr = TranslatorManager.boundTR;

// A modal popup that include the admin group box with a title
export class EmptyBox extends Component {
    render() {
        return (
            <Modal.ResponsiveEmptyBox {...this.props} container={this.props.container}>
                {this.props.children}
            </Modal.ResponsiveEmptyBox>
        );
    }
}
EmptyBox.propTypes = {
    container: PropTypes.object
};

export class ConfirmComponent extends Component {
    render() {
        let buttons = map(this.props.buttons, (button) => {
            return (
                <button
                    className={cIf({
                        btn: true,
                        "btn-default": button.kind == "" || button.kind == null || button.kind == "default",
                        "btn-primary": button.kind == "primary",
                        "btn-danger": button.kind == "danger",
                        "btn-warning": button.kind == "warning",
                        "btn-success": button.kind == "success"
                    })}
                    key={button.label}
                    onClick={button.onClick}
                >
                    {button.label}
                </button>
            );
        });

        let message = null;
        if(this.props.messagehtml != null)
            message = <div className="messagePanel" dangerouslySetInnerHTML={{__html: (this.props.messagehtml)}}></div>;
        else if(this.props.message != null)
            message = <div className="messagePanel">{this.props.message}</div>;
        else
            message = <div className="messagePanel">{this.props.children}</div>;

        return (
            <EmptyBox {...this.props} width={this.props.width} zIndex={this.props.zIndex} style={this.props.style}>
                <div className="confirm-box">
                    <div className="titlePanel">
                        <strong>{this.props.title}</strong>
                    </div>
                    <div className="contentPanel">
                        {message}
                        <div className="buttonPanel">
                            {buttons}
                        </div>
                    </div>
                </div>
            </EmptyBox>
        );
    }
}

ConfirmComponent.propTypes = {
    title: PropTypes.string, // The title
    message: PropTypes.string, // The "question"
    messagehtml: PropTypes.string, // The "question"
    buttons: PropTypes.array, // The buttons you want [ { label: "", onClick: function } ]
    width: PropTypes.number,
    zIndex: PropTypes.number,
    style: PropTypes.object
};
ConfirmComponent.defaultProps = {
    zIndex: 100000
};

// A confirm box!
export class Confirm extends Component {
    render() {
        return <ConfirmComponent {...this.props}>{this.props.children}</ConfirmComponent>;
    }
}

Confirm.propTypes = {
    title: PropTypes.string, // The title
    message: PropTypes.string, // The "question"
    messagehtml: PropTypes.string, // The "question"
    buttons: PropTypes.array, // The buttons you want [ { label: "", onClick: function } ]
    width: PropTypes.number,
    zIndex: PropTypes.number,
    style: PropTypes.object
};

// Confirm shortcuts
export class ConfirmOK extends Component {

    render() {
        const buttons = [
            { label: tr("Ok"), onClick: this.props.onOK, kind: "primary" }
        ];

        return ( <ConfirmComponent {...this.props} buttons={buttons}>{this.props.children}</ConfirmComponent> );
    }
}
ConfirmOK.propTypes = {
    onOK: PropTypes.func.isRequired
};

// Confirm shortcuts
export class ConfirmOKCancel extends Component {
    render() {
        const buttons = [
            { label: tr("Ok"), onClick: this.props.onOK, kind: "primary" },
            { label: tr("Annuler"), onClick: this.props.onCancel }
        ];

        return ( <ConfirmComponent {...this.props} buttons={buttons}>{this.props.children}</ConfirmComponent>);
    }
}
ConfirmOKCancel.propTypes = {
    onOK: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};


export class ConfirmYesNo extends Component {
    render() {
        const buttons = [
            { label: tr("Oui"), onClick: this.props.onYes, kind: "primary" },
            { label: tr("Non"), onClick: this.props.onNo }
        ];

        return ( <ConfirmComponent {...this.props} buttons={buttons}>{this.props.children}</ConfirmComponent>);
    }
}
ConfirmYesNo.propTypes = {
    onYes: PropTypes.func.isRequired,
    onNo: PropTypes.func.isRequired,
    style: PropTypes.object
};
